import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/images/coin_total.png';
const _hoisted_1 = { class: "flex flex-wrap items-center px-5 text-white bg-[#234652] rounded-small md:min-h-[80px]" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "py-3.5 w-full text-h4 leading-none border-b border-light-blue/20 border-solid md:mr-2.5 md:w-[145px] md:text-h2 md:border-none title-italic" }, " Total ", -1);
const _hoisted_3 = { class: "flex flex-wrap grow" };
const _hoisted_4 = { class: "grow py-2.5 pr-4 md:grow-0 md:pr-0 md:mr-10 md:min-w-[200px]" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "flex items-center mb-0.5" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 text-light-blue title" }, "Deposited")
], -1);
const _hoisted_6 = { class: "text-[1.75rem] leading-10/10 break-all md:text-h2 title-italic" };
const _hoisted_7 = { class: "grow py-2.5" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "flex items-center mb-0.5" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 text-light-blue title" }, "Earned BLID")
], -1);
const _hoisted_9 = { class: "flex items-center title-italic" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    class: "mr-0.5 -mb-[7px] h-[29px]",
    alt: "bolideCoins"
}, null, -1);
const _hoisted_11 = { class: "text-[1.75rem] leading-10/10 text-light-yellow break-all md:text-h2" };
const _hoisted_12 = {
    key: 0,
    class: "self-end pb-[3px] pl-1.5 leading-none text-green break-all"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, " $" + _toDisplayString(_ctx.formattedDeposit), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formattedEarnedBLID), 1),
                    (_ctx.formattedEarnedUSD !== '0')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "$" + _toDisplayString(_ctx.formattedEarnedUSD), 1))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
